import React from 'react';
import { buildClassName, deepCopy, mergeFields } from '../forms/formFunctions';
import { substitute } from '../../services/stringsubstitutions';

export const ContainerDiv = ({ formGenerator, field, additional, controller, collectionStack }) => {
    var rows = null;

    var createRows = () => {
        var items = Array.isArray(field.content)
                ? field.content
                : field.items ;
        return items.map((fld, sectionIndex) => {
            var newField = mergeFields(field, fld);

            const row = formGenerator.createControls(additional.addToValidationFunc, newField, '', collectionStack);
            return row;
        });
    };

    var onClick = () => {};

    if (field.events?.onClick != null) {
        onClick = (e) => {
            var copyStack = deepCopy(collectionStack);
            copyStack.reverse();

            formGenerator.runActions(
                field,
                field.events?.onClick,
                field.settings.value,
                formGenerator.getFormData(),
                copyStack,
                false,
                e
            );
        };
    }

    var formData = formGenerator.getFormData();

    if (field.header) {
        var header = substitute(field.header, formGenerator.props.controller, [...collectionStack, formData]);
        rows = <span className="" dangerouslySetInnerHTML={{ __html: header }} />;
    } else if (field.content && !Array.isArray(field.content)) {
        var fs = {
            type: 'formSection',
            key: field.content,
        };

        if (formGenerator.props.eventType === 'UPDATE_CONFIGS') field.items = [];
        if(field.items == null) field.items = [];
        if (field.items.length === 0) {
            field.items.items = [];
            field.items.push(fs);
        }

        rows = createRows();
    } else {
        rows = createRows();
    }

    var styles = null;
    if(field.styles){
        Object.entries(field.styles).forEach(([key, value]) => {
            if(styles == null)
                styles = deepCopy(field.styles);

            if(value.indexOf("${") > -1){
                styles[key] = substitute(value, formGenerator.props.controller, [...collectionStack, formData]);
            }
        });
    }

    styles = styles || field.styles;


    var copyStack = deepCopy(collectionStack);
    copyStack.reverse();

    var cls = buildClassName(formGenerator, field, '', field.class, copyStack);
    cls = substitute(cls, formGenerator.props.controller, [...copyStack, formGenerator.getFormData()]);

    return (
        <div
            id={field.id}
            style={styles}
            className={cls}
            onClick={(e) => {
                if (field.events?.onClick != null) {
                    onClick(e);
                }
            }}>
            {rows}
        </div>
    );
};
